// Module
var code = "<div class=\"content-pad alignc\"> <div> <icon name=\"warning\" style=\"font-size:4em\"></icon> </div> <h1>You do not have the required permission.</h1> <p>Please contact an administrator.</p> </div> ";
// Exports
export default code;